import { render, staticRenderFns } from "./opportunities.vue?vue&type=template&id=591f6e60&scoped=true&"
import script from "./opportunities.vue?vue&type=script&lang=js&"
export * from "./opportunities.vue?vue&type=script&lang=js&"
import style0 from "./opportunities.vue?vue&type=style&index=0&id=591f6e60&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f6e60",
  null
  
)

export default component.exports